import api from './api';
import { 
  createOverallPerformancePayload, 
  createEventsOverviewPayload,
  createSingleOverallFeedbackPayload,
  createSingleEventFeedbackPayload
} from '../utils/teacherPayloadUtils';

/**
 * Get score feedback for teacher dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getTeacherScoreFeedback = async (context, token) => {
  try {
    const payload = createOverallPerformancePayload(context);
    
    const response = await api.post('/analytics/dashboard/teacher/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher score feedback:', error);
    throw error;
  }
};

/**
 * Get score feedback for student dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getStudentScoreFeedback = async (context, token) => {
  try {
    const payload = createOverallPerformancePayload(context);
    
    const response = await api.post('/analytics/dashboard/student/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching student score feedback:', error);
    throw error;
  }
};

/**
 * Get events overview feedback for teacher dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getTeacherEventsOverviewFeedback = async (context, token) => {
  try {
    const payload = createEventsOverviewPayload(context);
    
    const response = await api.post('/analytics/dashboard/teacher/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher events overview feedback:', error);
    throw error;
  }
};

/**
 * Get events overview feedback for student dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getStudentEventsOverviewFeedback = async (context, token) => {
  try {
    const payload = createEventsOverviewPayload(context);
    
    const response = await api.post('/analytics/dashboard/student/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching student events overview feedback:', error);
    throw error;
  }
};

/**
 * Get course-specific feedback for teacher dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getTeacherCourseFeedback = async (context, token) => {
  try {
    const payload = createSingleOverallFeedbackPayload(context);
    
    const response = await api.post('/analytics/dashboard/teacher/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher course feedback:', error);
    throw error;
  }
};

/**
 * Get course-specific feedback for student dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getStudentCourseFeedback = async (context, token) => {
  try {
    const payload = createSingleOverallFeedbackPayload(context);
    
    const response = await api.post('/analytics/dashboard/student/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching student course feedback:', error);
    throw error;
  }
};

/**
 * Get dot click feedback for teacher dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getTeacherDotClickFeedback = async (context, token) => {
  try {
    const payload = createSingleEventFeedbackPayload(context);
    
    const response = await api.post('/analytics/dashboard/teacher/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher dot click feedback:', error);
    throw error;
  }
};

/**
 * Get dot click feedback for student dashboard
 * @param {object} context - Context object with required data for payload
 * @param {string} token - Authorization token
 * @returns {Promise} API response
 */
export const getStudentDotClickFeedback = async (context, token) => {
  try {
    const payload = createSingleEventFeedbackPayload(context);
    
    const response = await api.post('/analytics/dashboard/student/get-score-feedback/', payload, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching student dot click feedback:', error);
    throw error;
  }
};
